import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { useIsIndustryTaxonomyOptedIn } from "./useIsIndustryTaxonomyOptedIn";

export const useShowsIndustryTaxonomyAdminOffer = (): boolean => {
    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();

    return salesSettingsHelper.isAdmin() && !isIndustryTaxonomyOptedIn;
};
